export default "__VITE_ASSET__Des0Xuln__"